import productsCategoryData from '../data/home.json';
import React, { useState } from 'react';
import DButton from '../components/DButton';
import { useNavigate } from "react-router-dom";

const ProductSlider = ({ category }) => {
    const [productsCategory, setProductsCategory] = useState(productsCategoryData || []);
    const navigate = useNavigate();

    const navigateToProduct = (productId) => {
        navigate(`/product/${productId}`);
    }
    return (
        <>
            <div className="relative">
                <div className="zoom-container">
                    <img
                        className="object-fit w-full -mt-6 slider-container"
                        src={productsCategory[category].productSlider.imageUrl}
                        alt=""
                    />
                <div className="absolute top-8 lg:top-0">
                    <div className='relative flex flex-col justify-center text-center items-center h-full w-full lg:py-4 py-0'>
                        <h3 className="text-dinshaw-secondary leading-snug">
                            {category}
                        </h3>
                        <p className="text-gray-900 font--bold pt-4 px-8 w-full md:w-5/6 lg:w-4/6 leading-snug lg:leading-relaxed">
                            {productsCategory[category].productSlider.description}
                        </p>
                        <DButton clickHandler={navigateToProduct} inputProps={productsCategory[category].productId}>Know More</DButton>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default ProductSlider;